import React from 'react';
import IdleTimer from 'react-idle-timer';

interface IPropsControleSessao {
    
    timeout: number,
    children: any
}

let timer: any = undefined;

export const resetSessao = () => {
    timer && timer.reset();
}

const ControleSessao: React.FC<IPropsControleSessao> = (props) => {

    
    const onActive = (e: any) => {
    }
        

    // para ação que o usuário fizer com o teclado ou mouse
    const onAction = (e: any) => {
        // reseta o tempo da sessão
        timer && timer.reset();
    }

    return (
        <div>
            <IdleTimer
                ref={ref => { timer = ref }}
                element={document}
                onActive={onActive}
                onAction={onAction}
                debounce={250}
                timeout={props.timeout}>

                {props.children}

            </IdleTimer>
        </div >
    );
}

export default ControleSessao;